/**
 * The club runs on Mountain time, and everything scheduled here means Mountain
 * time regardless of where the admin happens to be sitting when they type it.
 */
export const CLUB_TIME_ZONE = "America/Denver";

/** Calendar/clock parts of an instant AS SEEN in a given zone. */
function partsInZone(date, timeZone) {
    const f = new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hour12: false,
    });
    const p = {};
    f.formatToParts(date).forEach(function (x) { if (x.type !== "literal") p[x.type] = x.value; });
    return {
        y: Number(p.year), m: Number(p.month) - 1, d: Number(p.day),
        H: Number(p.hour) % 24, M: Number(p.minute),
    };
}

/**
 * The instant at which the given wall-clock reading occurs in `timeZone`.
 *
 * Converges by measuring how far the guess lands from the target once rendered
 * back in the zone and correcting. Two passes settle it; the third covers the
 * daylight-saving boundaries, where the first correction can overshoot.
 */
export function zonedWallClockToDate(y, m, d, H, M, timeZone) {
    let ts = Date.UTC(y, m, d, H, M, 0, 0);
    for (let i = 0; i < 3; i++) {
        const p = partsInZone(new Date(ts), timeZone);
        const diff = Date.UTC(p.y, p.m, p.d, p.H, p.M) - Date.UTC(y, m, d, H, M);
        if (diff === 0) break;
        ts -= diff;
    }
    return new Date(ts);
}

/**
 * Combine the chosen calendar date with the chosen time, read as CLUB time.
 *
 * This used to call setHours(), which applies the BROWSER's zone, so the stored
 * instant depended on where the admin was. An admin in Paris entering 8:00 PM
 * stored 19:00Z; the same entry in Park City stored 03:00Z the next day - eight
 * hours apart for one intended event, and the Paris one showed to members as
 * noon. The date parts are still read locally because those are the calendar
 * day the admin picked; only the resulting instant is anchored to club time.
 */
export function mergeDateTime(startDate, startTime) {
    const startDateObj = startDate instanceof Date ? startDate : new Date(startDate);
    const timeParts = String(startTime).split(":");
    const H = parseInt(timeParts[0], 10) || 0;
    const M = parseInt(timeParts[1], 10) || 0;
    return zonedWallClockToDate(
        startDateObj.getFullYear(),
        startDateObj.getMonth(),
        startDateObj.getDate(),
        H, M,
        CLUB_TIME_ZONE
    );
}

export function mergeDateTime2(startDate, startTime) {
    // Parse startDate string
    const dateParts = startDate.toString().split(' ');
    const monthName = dateParts[1];
    const day = dateParts[2];
    const year = dateParts[3];
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames.indexOf(monthName);

    // Parse startTime string
    const timeParts = startTime.split(':');
    const hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);

    // Construct the date object with UTC time
    const startDateObj = new Date(Date.UTC(year, month, day, hours, minutes)).toISOString();

    return startDateObj; // Return the merged Date object
}



/**
 * The time as the CLUB sees it, so an admin editing from another country is
 * shown - and re-saves - the same time members will see. Previously used
 * getHours(), which rendered in the browser's zone.
 */
export function getTimeFromDate(dateString) {
    const p = partsInZone(new Date(dateString), CLUB_TIME_ZONE);
    return `${String(p.H).padStart(2, "0")}:${String(p.M).padStart(2, "0")}`;
}
export function getTimeFromDate2(dateString) {
    // Extract hours and minutes from the provided date string
    const hours = dateString.substring(11, 13);
    const minutes = dateString.substring(14, 16);
    return `${hours}:${minutes}`;
}

export function convertToMST1(userDateTimeString) {
    // Create a Date object using the user-provided date and time string
    var date = new Date(userDateTimeString);

    // Extract the timezone offset from the provided date string
    var offsetMinutes = date.getTimezoneOffset();

    // Convert the offset to milliseconds
    var offsetMilliseconds = offsetMinutes * 60 * 1000;

    // Adjust the time to MST (UTC-07:00)
    date.setTime(date.getTime() + offsetMilliseconds - (7 * 60 * 60 * 1000));

    // Format the date and time components
    var mstDate = date.toISOString().split('T')[0];

    // Extract MST hours and minutes
    var mstHours = date.getHours();
    var mstMinutes = date.getMinutes();

    // Determine AM/PM
    var ampm = mstHours >= 12 ? 'PM' : 'AM';

    // Convert MST hours to 12-hour format
    mstHours = mstHours % 12;
    mstHours = mstHours ? mstHours : 12; // Handle midnight (0 hours)

    // Construct the MST time string with AM/PM
    var mstTimeString = mstHours + ':' + ('0' + mstMinutes).slice(-2) + ' ' + ampm;

    // Construct the MST date and time string
    var mstDateTimeString = mstDate + ' ' + mstTimeString;

    return mstDateTimeString;
}
export function convertToMSTNew(userDateTimeString) {
    // Create a Date object from the user-provided string
    var date = new Date(userDateTimeString);

    // Convert to UTC by removing the local time zone offset
    var utcMilliseconds = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);

    // Now convert to MST (UTC-7), fixed (no DST)
    var offsetHours = 7;
    var mstMilliseconds = utcMilliseconds - (offsetHours * 60 * 60 * 1000);

    // Create a new Date object in MST
    var mstDate = new Date(mstMilliseconds);

    // === Custom formatting ===

    // Month names
    var monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Function to get ordinal suffix
    function getOrdinalSuffix(day) {
        if (day >= 11 && day <= 13) return day + 'th';
        switch (day % 10) {
            case 1: return day + 'st';
            case 2: return day + 'nd';
            case 3: return day + 'rd';
            default: return day + 'th';
        }
    }

    var mstDay = mstDate.getDate();
    var mstMonth = monthNames[mstDate.getMonth()];
    var mstYear = mstDate.getFullYear();

    var mstHours = mstDate.getHours();
    var mstMinutes = mstDate.getMinutes();
    var ampm = mstHours >= 12 ? 'PM' : 'AM';

    mstHours = mstHours % 12;
    mstHours = mstHours ? mstHours : 12; // Handle midnight

    var formattedTime = mstHours + ':' + ('0' + mstMinutes).slice(-2) + ' ' + ampm;
    var formattedDate = mstMonth + ' ' + getOrdinalSuffix(mstDay) + ', ' + mstYear + ' at ' + formattedTime;

    return formattedDate;
}

export const BookingCategory = {
    Vehicle_Booking: "Vehicle_Booking",
    Addition_Amount: "Addition_Amount",
    Paid_after_Rental: "Paid_after_Rental",
    Product_Purchase: "Product_Purchase",
    Paid_Event_RSVP: "Paid_Event_RSVP",
    POS_FoodAndB: "Food_and_Beverage",
    Event_RSVP_Refund: "Event_RSVP_Refund",
    // End-of-year minimum-spend shortfall, charged in January for the year that
    // just closed. calculateTotals on the server excludes this marker so the
    // charge cannot count toward the following year's minimum - keep the two in
    // step if this string ever changes.
    Minimum_Spend_Adjustment: "Minimum_Spend_Adjustment",
  };

  export const BOOKINGSTATUS = {
    Attending: "Attending",
    Cancel: "Cancel",
    Waiting: "Waiting",
}
